// -----------------------------------------------------------------------------
// スナックバー オペレーション
// -----------------------------------------------------------------------------
import {SnackMessage} from './types';
import {add, del, clear} from './actions';

/**
 * メッセージ作成
 *
 * @param {String} gmnId - 画面ID
 * @param {String} msgId - メッセージID
 * @param {...String} msgArgs - メッセージ引数
 * @return {Function} ディスパッチ関数
 */
export const createMessage = (gmnId, msgId, ...msgArgs) => {
  return async (dispatch) => {
    const message = await SnackMessage.create(msgId, msgArgs, gmnId);
    const action = add(message);
    dispatch(action);
  };
};

/**
 * メッセージ追加
 *
 * @param {SnackMessage} message - メッセージオブジェクト
 * @return {Function} ディスパッチ関数
 */
export const appendMessage = (message) => {
  return async (dispatch) => {
    message = await remakeMessage(message);
    const action = add(message);
    dispatch(action);
  };
};

/**
 * メッセージ削除
 *
 * @param {SnackMessage} message - メッセージオブジェクト
 * @return {Function} ディスパッチ関数
 */
export const deleteMessage = (message) => {
  return async (dispatch) => {
    message = await remakeMessage(message);
    const action = del(message);
    dispatch(action);
  };
};

/**
 * メッセージクリア
 *
 * - 指定した表示区分以外のメッセージを削除
 *
 * @param {String} category - 表示区分(画面ID)
 * @return {Function} ディスパッチ関数
 */
export const clearMessages = (category) => {
  return (dispatch) => {
    const action = clear(category);
    dispatch(action);
  };
};

// -----------------------------------------------------------------------------
// ヘルパーメソッド
// -----------------------------------------------------------------------------
// メッセージ再作成
async function remakeMessage(message) {
  // ハッシュ値計算
  if (typeof message.makeHash === 'function') {
    return message.makeHash();
  }

  // ストレージから復元したオブジェクトは
  // makeHash() メソッドがないので再作成
  return SnackMessage.copy(message).makeHash();
}

// -----------------------------------------------------------------------------
// エクスポート
// -----------------------------------------------------------------------------
export default {
  createMessage,
  appendMessage,
  deleteMessage,
  clearMessages,
};
